<template>
  <section class="section-product-detail-page bg-grey">
    <div class="container">
      <div class="row m-0">
        <div class="col-12">
          <div class="content py-0">
            <h2 class="section-title page-title h2 text-center text-black f-44 h2-caslon">Medical Devices</h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">

        <div class="content">
          <ContentsTextWithImage
            title="Medical Devices"
            image-url="/pages/products/industries/medical.jpg"
            :contents="[
              'Healthcare segment is growing rapidly and is one of Thailand S-curve industry. Plastics used in medical equipment are unique since it requires compliance with ever changing regulation, compatibility with human body, exposure to various chemicals, and use with different sterilization methods. We supply plastics that has optical clarity to see things inside and remain transparency when gone through multiple cycles of sterilization, plastic with EMI shielding to protect signal in hospital to interfere device performance, and plastic with certified medical grade, UPS class IV, US FDA, European food contact. Recently, since Covid-19 medical devices are more often cleaned by disinfectants, we are offering new plastic type that is resistant to its special chemicals. Typical materials are TPE, ABS, PC, PC/ABS, PPE, and PEI. Example application',
            ]"
            is-reverse="true"
            is-white-content="true"
            is-content-small-text="true"
            left-width="45.805%"
            right-width="54.195%"
          />
        </div>
        
      </div>
    </div>
  </section>

  <section class="section-gallery bg-grey">

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/e-medical.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Medical connector</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/e-dialy.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Dialysis housing</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/e-viral.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Vial, bottle</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/e-infusion.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Infusion and syringe pump</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/e-syring.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Syringe</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/e-ster.jpg" alt="">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Sterilization tray</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

  </section>
</template>
<script setup lang="ts">
useHead({
  title:'Medical Devices - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.page-title {
  padding-bottom: 60px;
}

.section-gallery {
  padding-top: 60px;
}
</style>